import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isTomorrowList } from '../constants/listTypes';

export default function MobileListSelector({ lists, activeListId, onSelectList, onCreateNew, isMainList }) {
  const navigate = useNavigate();
  const location = useLocation();
  const activeList = lists.find(list => list.id === activeListId);
  const isTomorrow = activeList && isTomorrowList(activeList.list_type);

  const handleClick = () => {
    // Navigate to list selection page with current path as return path
    navigate('/lists', { state: { returnPath: location.pathname } });
  };

  return (
    <div className="mobile-list-selector" onClick={handleClick}>
      <div className="mobile-list-display">
        <span className="mobile-list-title">
          {isTomorrow ? 'To Do Tomorrow' : activeList?.name}
          {activeList?.is_shared && (
            <svg 
              className="shared-icon" 
              width="16" 
              height="16" 
              viewBox="0 0 20 20" 
              fill="currentColor"
              title="Shared list"
            >
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
            </svg>
          )}
        </span>
        <svg className="mobile-list-chevron" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>
    </div>
  );
}

